<template>
  <div>
    <top />
    <div class="main home clearfix">
      <div class="fl">
        <h1>产品与服务</h1>
        <ul class="menus">
          <li class="menu">
            <div class="f-menus" @mouseover="hover1 = true" @mouseleave="hover1 = false">
              <span :class="{f_menus_hover: currentName === 'data'}">
                <router-link
                  :to="{path:'/product_service/data',query:{param:'大数据产品',child:'文献库'}}"
                >经济社会大数据服务</router-link>
              </span>
            </div>
            <!-- <ul
              class="s-menus"
              @mouseover="hover1 = true"
              @mouseleave="hover1 = false"
              :class="{show:hover1}"
            >
              <li class="s-menu">
                <div class="s-menu-t">大数据产品</div>
                <ul class="t-menus">
                  <router-link
                    :to="{path:'/product_service/data',query:{param:'大数据产品',child:'文献库'}}"
                  >
                    <li class="t-menu">文献库</li>
                  </router-link>
                  <router-link
                    :to="{path:'/product_service/data',query:{param:'大数据产品',child:'数据库'}}"
                  >
                    <li class="t-menu">数据库</li>
                  </router-link>
                  <router-link
                    :to="{path:'/product_service/data',query:{param:'大数据产品',child:'特色库'}}"
                  >
                    <li class="t-menu">特色库</li>
                  </router-link>
                </ul>
              </li>
              <li class="s-menu">
                <router-link :to="{path:'/product_service/data',query:{param:'信息定制'}}">
                  <div class="s-menu-t">信息定制</div>
                </router-link>
              </li>
              <li class="s-menu">
                <router-link :to="{path:'/product_service/data',query:{param:'新媒体运营'}}">
                  <div class="s-menu-t">新媒体运营</div>
                </router-link>
              </li>
            </ul>-->
          </li>
          <li class="menu">
            <div class="f-menus" @mouseover="hover2 = true" @mouseleave="hover2 = false">
              <span :class="{f_menus_hover: currentName === 'research'}">
                <router-link
                  :to="{path:'/product_service/research',query:{param:'政策规划咨询'}}"
                >经济课题研究咨询</router-link>
              </span>
            </div>
            <!-- <ul
              class="menu-ul clearfix"
              @mouseover="hover2 = true"
              @mouseleave="hover2 = false"
              :class="{show:hover2}"
            >
              <li class="menu-li">
                <router-link :to="{path:'/product_service/research',query:{param:'政策规划咨询'}}">
                  <img src="@/assets/images/icon1.png" alt />
                  <p>政策规划咨询</p>
                </router-link>
              </li>
              <li class="menu-li">
                <router-link :to="{path:'/product_service/research',query:{param:'经济运行分析'}}">
                  <img src="@/assets/images/icon2.png" alt />
                  <p>经济运行分析</p>
                </router-link>
              </li>
              <li class="menu-li">
                <router-link :to="{path:'/product_service/research',query:{param:'园区产业规划'}}">
                  <img src="@/assets/images/icon3.png" alt />
                  <p>园区产业规划</p>
                </router-link>
              </li>
              <li class="menu-li">
                <router-link :to="{path:'/product_service/research',query:{param:'信息化课题研究'}}">
                  <img src="@/assets/images/icon4.png" alt />
                  <p>信息化课题研究</p>
                </router-link>
              </li>
              <li class="menu-li">
                <router-link :to="{path:'/product_service/research',query:{param:'管理课题研究'}}">
                  <img src="@/assets/images/icon5.png" alt />
                  <p>管理课题研究</p>
                </router-link>
              </li>
            </ul>-->
          </li>
          <li class="menu">
            <div class="f-menus" @mouseover="hover3 = true" @mouseleave="hover3 = false">
              <span :class="{f_menus_hover: currentName === 'infor'}">
                <router-link
                  :to="{path:'/product_service/infor',query:{param:'解决方案',child:'经济监测分析平台'}}"
                >经济社会信息平台建设</router-link>
              </span>
            </div>
            <!-- <ul
              class="s-menus"
              @mouseover="hover3 = true"
              @mouseleave="hover3 = false"
              :class="{show:hover3}"
            >
              <li class="s-menu">
                <div class="s-menu-t">解决方案</div>
                <ul class="t-menus">
                  <router-link
                    :to="{path:'/product_service/infor',query:{param:'解决方案',child:'经济监测分析平台'}}"
                  >
                    <li class="t-menu">经济监测分析平台</li>
                  </router-link>
                  <router-link
                    :to="{path:'/product_service/infor',query:{param:'解决方案',child:'智库网站建设'}}"
                  >
                    <li class="t-menu">智库网站建设</li>
                  </router-link>
                </ul>
              </li>
              <li class="s-menu">
                <router-link :to="{path:'/product_service/infor',query:{param:'相关模型'}}">
                  <div class="s-menu-t">相关模型</div>
                </router-link>
              </li>
              <li class="s-menu">
                <router-link :to="{path:'/product_service/infor',query:{param:'核心技术'}}">
                  <div class="s-menu-t">核心技术</div>
                </router-link>
              </li>
              <li class="s-menu">
                <router-link :to="{path:'/product_service/infor',query:{param:'典型案例'}}">
                  <div class="s-menu-t">典型案例</div>
                </router-link>
              </li>
            </ul>-->
          </li>
        </ul>
      </div>
      <div class="fr" style="width:890px">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// import $ from "jquery";
// debugger
// $(".f-menus,.s-menus").hover(
//   function() {
//     $(".s-menus").addClass("show");
//   },
//   function() {
//     $(".s-menus").removeClass("show");
//   }
// );
export default {
  data() {
    return {
      hover1: false,
      hover2: false,
      hover3: false,
      currentName: ""
    };
  },
  watch: {
    $route: {
      handler(to) {
        // if (to.name === "data") {
        this.currentName = to.name;
        // }
        // this.currentUrl = to.path;
        // this.keyword = to.query.keyword;
      },
      immediate: true
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  margin-top: 32px;
  // 左侧导航
  h1 {
    width: 260px;
    height: 66px;
    background: #1967b6;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    line-height: 66px;
    text-align: left;
    padding: 0 30px;
  }
  a,
  .show {
    display: block !important;
  }
  .menus {
    background: #f4f6f7;
    padding: 20px 0px;
    // 一级菜单
    .menu {
      position: relative;
      .f-menus {
        width: 100%;
        font-size: 16px;
        padding: 0 20px;
        span {
          display: block;
          a {
            display: block;
            line-height: 62px;
            padding-left: 10px;
            color: #000000;
          }
        }
      }
      &:hover .f-menus a{
        font-weight: bold;
        color: #1967b6;
        cursor: pointer;
      }
      .f_menus_hover a{
        font-weight: bold;
        color: #1967b6!important;
      }
    }
    .menu + .menu {
      .f-menus span {
        border-top: 1px solid #e4e7e8;
      }
    }
  }
  // 二级菜单
  .s-menus {
    display: none;
    background: #fff url(../assets/images/service.png) right bottom no-repeat;
    width: 632px;
    height: 228px;
    border: 1px solid #e9e9e9;
    box-shadow: 0px 5px 15px 0px rgba(207, 207, 207, 0.8);
    padding: 0 18px;
    position: absolute;
    left: 260px;
    top: -20px;
    z-index: 99;
    .s-menu {
      width: 198px;
      height: 143px;
      margin-top: 26px;
      float: left;
      .s-menu-t {
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: #000000;
        line-height: 48px;
        list-style: none;
        &:hover {
          color: #1967b6;
          cursor: pointer;
        }
      }
      .t-menus {
        .t-menu {
          list-style: disc;
          width: 50px;
          font-size: 14px;
          font-weight: 400;
          color: #696969;
          line-height: 32px;
          margin-left: 84px;
          &:hover {
            color: #1967b6;
            cursor: pointer;
          }
        }
      }
    }
    .s-menu + .s-menu {
      border-left: 1px solid #e4e7e8;
    }
  }
  .menu:nth-child(3) {
    .s-menus {
      width: 830px;
      top: -147px;
      .s-menu .t-menus .t-menu {
        width: 112px;
        margin-left: 60px;
      }
    }
  }
  .menu-ul {
    display: none;
    background: #fff url(../assets/images/service.png) right bottom no-repeat;
    width: 938px;
    height: 228px;
    border: 1px solid #e9e9e9;
    box-shadow: 0px 5px 15px 0px rgba(207, 207, 207, 0.8);
    padding: 0 18px;
    position: absolute;
    left: 260px;
    top: -84px;
    z-index: 99;
    .menu-li {
      width: 180px;
      height: 120px;
      float: left;
      margin-top: 46px;
      a {
        display: block;
      }
      img {
        display: block;
        margin: 10px auto;
      }
      p {
        line-height: 30px;
        text-align: center;
        color: #333333;
      }
      &:hover {
        background: #f4f6f7;
        cursor: pointer;
      }
    }
    .menu-li + .menu-li {
      border-left: 1px solid #f0f1f2;
    }
  }
}
</style>